import {
  Background,
  CanvasContainer,
  CloseButton,
  Container,
  ContainerBox,
  PreviewRow,
  PreviewTop,
  TimerRow,
  Wrapper,
} from './RewardQRScreen.styled';
import { DisableScroll, EnableScroll } from '@utils/scrollController';
import CrossIcon from '@assets/svg/match/missing.svg';
import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { useQRCode } from 'next-qrcode';
import BGIn from 'src/lotties/bgIn.json';
import Lottie from 'react-lottie-player';
import { useStore } from '@store/appStore';
import moment from 'moment';
import db from '@utils/db';
import CompletionAnimation from '@lotties/lf30_dr1ljkp3.json';
import Timer from '@components/Buttons/Timer';
import Modal from '@components/Buttons/Modal';
import { HeadLine, PopClose, PopContainer, PopRow, PopTitle } from '@components/Guardian/Guardian.styled';

const AnimationBGIn = {
  loop: true,
  animationData: BGIn,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

interface IProps {
  screenTitle: string;
  badge?: any;
  closeScreen?: (closeScreen: boolean) => void;
  tmp?: () => void;
  updateCoins?: () => void;
}

const RewardQRScreen = (props: IProps) => {
  const { badge } = useStore();
  const [start, setStart] = useState(false);
  const [redeem, setRedeem] = useState(false);
  const checkTimer = useRef(null);
  const closeTimer = useRef(null);
  const { Canvas } = useQRCode();
  const i18n = useI18n();
  const ref = useRef(null)

  useEffect(() => {
    setStart(true);
    return () => {
      clearTimeout(checkTimer.current);
    };
  }, []);

  const OnCloseScreen = async (timer = 0) => {
    setTimeout(async () => {
      props.updateCoins();
      await db.Reward_UnusedDeleteReservation(badge.qr);
      setStart(false);
      props.closeScreen(false);
    }, timer);
  };

  useEffect(() => {
    if (start) {
      SetCloseTimer();
      closeTimer.current = moment().add(badge.duration,'minutes').toDate();
      checkTimer.current = setTimeout(async () => {
        await checkRedeem();
      }, 1000);
    }
  }, [start]);

  useEffect(() => {
    if (redeem) OnCloseScreen(3000);
  }, [redeem]);

  const checkRedeem = async () => {
    let redeemed = await db.IsRewardRedeemed(badge.qr);
    if (redeemed.length > 0 && redeemed[0].redeemed) {      
      setRedeem(true);
    } else {
      checkTimer.current = setTimeout(async () => {
        await checkRedeem();
      }, 1000);
    }
  };

  const SetCloseTimer = () => {
    let now = moment();
    let then = moment().add(badge.duration, 'minutes');
    let duration = moment.duration(then.diff(now, 'milliseconds'));
    let time = duration.asMilliseconds();
    if (closeTimer.current !== null) {
      clearTimeout(closeTimer.current);
    }
    closeTimer.current = setTimeout(() => {
      OnCloseScreen();
    }, time);
  };

  const animationOption = {
    loop: false,
    animationData: CompletionAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid',
    },
  };

  return (
    <Modal ref={ref} onClose={props.closeScreen} backColor={"rgba(0,0,0,0.25)"}>
      <PopContainer mid={true} normalPad={true} >
        <PopTitle>{badge.title}</PopTitle>
        <PopClose onClick={() => ref.current.handleClose()}><CrossIcon /></PopClose>
        <HeadLine />
          <div style={{position:"relative", width:"100%", aspectRatio:"1 / 1.4"}}>

          <ContainerBox>
            <Background>
              <Lottie {...AnimationBGIn} play style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} />
            </Background>
            <PreviewRow>
              {redeem ? (
                <CanvasContainer>
                  <Lottie {...animationOption} play style={{width:'100%',height:400,overflow:'hidden',margin:'0 auto'}} />
                </CanvasContainer>
              ) : (
                <CanvasContainer>
                  <Canvas text={badge.qr} options={{ margin: 2, color: { dark: '#000000', light: '#ffbf600' } }} />
                </CanvasContainer>
              )}
            </PreviewRow>
            <TimerRow center={true}>
              <div>
                <Timer time={closeTimer.current ? closeTimer.current : null} />
              </div>
            </TimerRow>
          </ContainerBox>
          </div>
      </PopContainer>
    </Modal>

  );
};

export default RewardQRScreen;
